import { RouteRecordRaw } from 'vue-router'

import dashboardRoutes from './dashboard'
// import componentsRoutes from './components'
// import functionRoutes from './function'
// import hooksRoutes from './hooks'
// import levelRoutes from './level'
// import exampleRoutes from './example'
// import errorRoutes from './error'
// import authorizationRoutes from './authorization'
import adminRoutes from './admin'
import systemRoutes from './system'

// 异步路由集合
export const asyncRoutes: RouteRecordRaw[] = [
  ...dashboardRoutes,
  ...adminRoutes,
  // ...componentsRoutes,
  // ...functionRoutes,
  // ...hooksRoutes,
  // ...levelRoutes,
  // ...exampleRoutes,
  // ...errorRoutes,
  // ...authorizationRoutes,
  ...systemRoutes
]

export default asyncRoutes
